module.exports = __webpack_public_path__ + "static/media/logo-haze.366232c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo-haze.png
// module id = 290
// module chunks = 18